import {
  CreatedBy,
  DeliveryStatus,
  ScheduleMode,
} from '../../../../../../views/marketing/push-notifications/Constants';

export default {
  title: 'Campaigns',
  filters: {
    search: 'Search campaigns...',
  },
  columns: {
    title: 'Title',
    created_by: 'Created by',
    schedule_mode: 'Schedule Mode',
    scheduled_at: 'Scheduled at',
    sent_at: 'Sent at',
    status: 'Status',
    sent: 'Sent',
    delivered: 'Delivered',
    delivered_rate: 'Delivered Rate',
    clicks: 'Clicks',
    click_rate: 'Click Rate',
    live: 'Live',
    actions: 'Actions',
  },
  active_status: {
    draft: 'Draft',
    active: 'Active',
  },
  delivery: {
    in_progress: 'Awaiting confirmation',
    awaiting: 'Awaiting confirmation',
    verified: 'Verified {{relative}}',
    next_check_around: 'Next check around {{time}}',
  },
  breakdown: {
    delivered: '{{count}} delivered',
    pending: '{{count}} awaiting confirmation',
    failed_title: 'Not delivered',
    all_delivered: 'Delivered to all recipients.',
    load_error: 'Could not load the delivery breakdown.',
    reasons: {
      DeviceNotRegistered: 'App removed or notifications turned off (expired token)',
      MessageRateExceeded: 'Temporarily rate-limited by Expo',
      MessageTooBig: 'Notification payload too large',
      MismatchSenderId: 'Push credentials mismatch',
      InvalidCredentials: 'Invalid push credentials',
      batch_failed: 'Send batch failed',
      missing_ticket: 'No confirmation returned by Expo',
      unknown: 'Unknown delivery error',
    },
  },
  created_by: {
    [CreatedBy.System]: 'System',
    [CreatedBy.User]: 'User',
  },
  schedule_mode: {
    [ScheduleMode.Instant]: 'Instant',
    [ScheduleMode.Scheduled]: 'Scheduled',
  },
  delivery_status: {
    [DeliveryStatus.Sending]: 'Sending',
    [DeliveryStatus.Sent]: 'Sent',
    [DeliveryStatus.Queued]: 'Queued',
    [DeliveryStatus.Failed]: 'Failed',
  },
  actions: {
    details: 'Details',
    view_details: 'View Details',
    resend: 'Resend',
    duplicate_edit: 'Duplicate & Edit',
    delete: 'Delete',
    edit: 'Edit',
    activate: 'Activate',
    deactivate: 'Deactivate',
  },
  success_messages: {
    campaign_updated: 'Campaign updated successfully',
    campaign_deleted: 'Campaign deleted successfully',
  },
  error_messages: {
    failed_to_update_campaign: 'Failed to update campaign',
    failed_to_load_data: 'Failed to load data',
    failed_to_delete_campaign: 'Failed to delete campaign',
  },
};
